import React from "react";
import { Content } from "./Content";
import Grid from "./Grid";
import { QuoteForm } from "./QuoteForm";

export const ContentAndQuote = ({ content, source }) => {
  return (
    <Grid columnGap="loose">
      <Grid item lg="8" columnGap="loose">
        <Content content={content} />
      </Grid>
      <Grid item lg="4" columnGap="loose">
        <QuoteForm source={source} />
      </Grid>
    </Grid>
  );
};
